import {ImportingDataTypes} from "../../types";

/** Import types that require an explicit industry selection. */
export const INDUSTRY_SCOPED_IMPORT_TYPES = {
    partTechnicalInformation: ImportingDataTypes.partTechnicalInformation,
    productProperties: ImportingDataTypes.productProperties,
    productPropertyOptions: ImportingDataTypes.productPropertyOptions,
    externalProducts: ImportingDataTypes.externalProducts,
    productTagAssignment: ImportingDataTypes.productTagAssignment,
};

export const INDUSTRY_SCOPED_IMPORT_BASE_IDS = Object.values(INDUSTRY_SCOPED_IMPORT_TYPES);

/**
 * @param {string} [dataSourceId]
 * @returns {boolean}
 */
export const isIndustryScopedImportDataSource = (dataSourceId) =>
    INDUSTRY_SCOPED_IMPORT_BASE_IDS.includes(dataSourceId);

/**
 * Resolves the active industry for an industry-scoped import session.
 * @param {string} [dataSourceId]
 * @param {string|number|null|undefined} [importIndustryId]
 * @returns {string|undefined}
 */
export const resolveImportIndustryId = (dataSourceId, importIndustryId) => {
    if (!isIndustryScopedImportDataSource(dataSourceId)) {
        return undefined;
    }
    if (importIndustryId == null || importIndustryId === '') {
        return undefined;
    }
    return String(importIndustryId);
};

/**
 * Props for {@link PartAutocomplete} from import static context.
 * @param {{ industryId?: string }} [staticDataContext]
 * @returns {{ industryId?: string }}
 */
export const getPartAutocompletePropsFromImportContext = (staticDataContext) => {
    const industryId = staticDataContext?.industryId;
    return industryId ? {industryId} : {};
};
